var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRocketStartup = function SvgRocketStartup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E4F7F8",
    d: "M8.32 46.933a31.68 31.68 0 1 0 63.36 0 31.68 31.68 0 0 0-63.36 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.17 65.255a31.665 31.665 0 0 0 51.664 0 5.94 5.94 0 0 0-10.575-1.432 5.9 5.9 0 0 0-3.933-1.029 7.85 7.85 0 0 0-8.855-6.28 18.2 18.2 0 0 1-.887-5.627V44.55h-3.168v6.336c0 1.91-.3 3.81-.89 5.628a7.85 7.85 0 0 0-8.852 6.28 5.908 5.908 0 0 0-3.931 1.029 5.94 5.94 0 0 0-10.575 1.431z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.834 65.255a5.94 5.94 0 0 0-10.575-1.432 5.9 5.9 0 0 0-3.933-1.029 7.85 7.85 0 0 0-8.855-6.28 18.2 18.2 0 0 1-.887-5.627V44.55h-3.168v6.336c0 1.91-.3 3.81-.89 5.628a7.85 7.85 0 0 0-8.852 6.28 5.908 5.908 0 0 0-3.931 1.029 5.94 5.94 0 0 0-10.575 1.431"
  }), /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.2,
    d: "M65.834 65.255a5.94 5.94 0 0 0-10.575-1.432 5.9 5.9 0 0 0-3.933-1.029 7.85 7.85 0 0 0-8.855-6.28 18.2 18.2 0 0 1-.887-5.627V44.55h-3.168v6.336c0 1.91-.3 3.81-.89 5.628a7.85 7.85 0 0 0-8.852 6.28 5.908 5.908 0 0 0-3.931 1.029 5.94 5.94 0 0 0-10.575 1.431"
  }), /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.2,
    d: "M65.834 65.255a5.94 5.94 0 0 0-10.575-1.432 5.9 5.9 0 0 0-3.933-1.029 7.85 7.85 0 0 0-8.855-6.28 18.2 18.2 0 0 1-.887-5.627V44.55h-3.168v6.336c0 1.91-.3 3.81-.89 5.628a7.85 7.85 0 0 0-8.852 6.28 5.908 5.908 0 0 0-3.931 1.029 5.94 5.94 0 0 0-10.575 1.431"
  }), /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.2,
    d: "M65.834 65.255a5.94 5.94 0 0 0-10.575-1.432 5.9 5.9 0 0 0-3.933-1.029 7.85 7.85 0 0 0-8.855-6.28 18.2 18.2 0 0 1-.887-5.627V44.55h-3.168v6.336c0 1.91-.3 3.81-.89 5.628a7.85 7.85 0 0 0-8.852 6.28 5.908 5.908 0 0 0-3.931 1.029 5.94 5.94 0 0 0-10.575 1.431"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCE7E0",
    d: "m48.01 70.265-1.436-.832a6.8 6.8 0 0 0 0-3.444l1.439-.833a.713.713 0 0 0 .26-.972l-1.07-1.85a.713.713 0 0 0-.973-.26l-1.44.83a6.75 6.75 0 0 0-2.983-1.721V59.52a.713.713 0 0 0-.713-.713h-2.139a.713.713 0 0 0-.712.713v1.663a6.74 6.74 0 0 0-2.982 1.722l-1.439-.831a.71.71 0 0 0-.973.26l-1.068 1.85a.713.713 0 0 0 .26.972l1.44.833a6.8 6.8 0 0 0 0 3.444l-1.44.832a.713.713 0 0 0-.26.972l1.068 1.85a.713.713 0 0 0 .973.261l1.441-.83a6.75 6.75 0 0 0 2.982 1.722v1.663a.713.713 0 0 0 .713.713h2.138a.713.713 0 0 0 .713-.713V74.24a6.75 6.75 0 0 0 2.983-1.723l1.44.831a.71.71 0 0 0 .973-.26l1.068-1.85a.713.713 0 0 0-.263-.973m-7.984.972a3.526 3.526 0 1 1-.002-7.053 3.526 3.526 0 0 1 .002 7.053"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "m48.01 70.265-1.436-.832a6.8 6.8 0 0 0 0-3.444l1.439-.833a.713.713 0 0 0 .26-.972l-1.07-1.85a.713.713 0 0 0-.973-.26l-1.44.83a6.75 6.75 0 0 0-2.983-1.721V59.52a.713.713 0 0 0-.713-.713h-2.139a.713.713 0 0 0-.712.713v1.663a6.74 6.74 0 0 0-2.982 1.722l-1.439-.831a.71.71 0 0 0-.973.26l-1.068 1.85a.713.713 0 0 0 .26.972l1.44.833a6.8 6.8 0 0 0 0 3.444l-1.44.832a.713.713 0 0 0-.26.972l1.068 1.85a.713.713 0 0 0 .973.261l1.441-.83a6.75 6.75 0 0 0 2.982 1.722v1.663a.713.713 0 0 0 .713.713h2.138a.713.713 0 0 0 .713-.713V74.24a6.75 6.75 0 0 0 2.983-1.723l1.44.831a.71.71 0 0 0 .973-.26l1.068-1.85a.713.713 0 0 0-.263-.973m-7.984.972a3.526 3.526 0 1 1-.002-7.053 3.526 3.526 0 0 1 .002 7.053"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "m48.01 70.265-1.436-.832a6.8 6.8 0 0 0 0-3.444l1.439-.833a.713.713 0 0 0 .26-.972l-1.07-1.85a.713.713 0 0 0-.973-.26l-1.44.83a6.75 6.75 0 0 0-2.983-1.721V59.52a.713.713 0 0 0-.713-.713h-2.139a.713.713 0 0 0-.712.713v1.663a6.74 6.74 0 0 0-2.982 1.722l-1.439-.831a.71.71 0 0 0-.973.26l-1.068 1.85a.713.713 0 0 0 .26.972l1.44.833a6.8 6.8 0 0 0 0 3.444l-1.44.832a.713.713 0 0 0-.26.972l1.068 1.85a.713.713 0 0 0 .973.261l1.441-.83a6.75 6.75 0 0 0 2.982 1.722v1.663a.713.713 0 0 0 .713.713h2.138a.713.713 0 0 0 .713-.713V74.24a6.75 6.75 0 0 0 2.983-1.723l1.44.831a.71.71 0 0 0 .973-.26l1.068-1.85a.713.713 0 0 0-.263-.973m-7.984.972a3.526 3.526 0 1 1-.002-7.053 3.526 3.526 0 0 1 .002 7.053"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "m48.01 70.265-1.436-.832a6.8 6.8 0 0 0 0-3.444l1.439-.833a.713.713 0 0 0 .26-.972l-1.07-1.85a.713.713 0 0 0-.973-.26l-1.44.83a6.75 6.75 0 0 0-2.983-1.721V59.52a.713.713 0 0 0-.713-.713h-2.139a.713.713 0 0 0-.712.713v1.663a6.74 6.74 0 0 0-2.982 1.722l-1.439-.831a.71.71 0 0 0-.973.26l-1.068 1.85a.713.713 0 0 0 .26.972l1.44.833a6.8 6.8 0 0 0 0 3.444l-1.44.832a.713.713 0 0 0-.26.972l1.068 1.85a.713.713 0 0 0 .973.261l1.441-.83a6.75 6.75 0 0 0 2.982 1.722v1.663a.713.713 0 0 0 .713.713h2.138a.713.713 0 0 0 .713-.713V74.24a6.75 6.75 0 0 0 2.983-1.723l1.44.831a.71.71 0 0 0 .973-.26l1.068-1.85a.713.713 0 0 0-.263-.973m-7.984.972a3.526 3.526 0 1 1-.002-7.053 3.526 3.526 0 0 1 .002 7.053"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "m48.01 70.265-1.436-.832a6.8 6.8 0 0 0 0-3.444l1.439-.833a.713.713 0 0 0 .26-.972l-1.07-1.85a.713.713 0 0 0-.973-.26l-1.44.83a6.75 6.75 0 0 0-2.983-1.721V59.52a.713.713 0 0 0-.713-.713h-2.139a.713.713 0 0 0-.712.713v1.663a6.74 6.74 0 0 0-2.982 1.722l-1.439-.831a.71.71 0 0 0-.973.26l-1.068 1.85a.713.713 0 0 0 .26.972l1.44.833a6.8 6.8 0 0 0 0 3.444l-1.44.832a.713.713 0 0 0-.26.972l1.068 1.85a.713.713 0 0 0 .973.261l1.441-.83a6.75 6.75 0 0 0 2.982 1.722v1.663a.713.713 0 0 0 .713.713h2.138a.713.713 0 0 0 .713-.713V74.24a6.75 6.75 0 0 0 2.983-1.723l1.44.831a.71.71 0 0 0 .973-.26l1.068-1.85a.713.713 0 0 0-.263-.973m-7.984.972a3.526 3.526 0 1 1-.002-7.053 3.526 3.526 0 0 1 .002 7.053"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCE7E0",
    d: "M32.263 35.115c-.247.287-6.293 6.348-3.257 15.096q.522 1.51 1.21 3.398a.29.29 0 0 0 .549-.113l.482-4.69a8.13 8.13 0 0 1 3.228-5.717z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M32.263 35.115c-.247.287-6.293 6.348-3.257 15.096q.522 1.51 1.21 3.398a.29.29 0 0 0 .549-.113l.482-4.69a8.13 8.13 0 0 1 3.228-5.717z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M32.263 35.115c-.247.287-6.293 6.348-3.257 15.096q.522 1.51 1.21 3.398a.29.29 0 0 0 .549-.113l.482-4.69a8.13 8.13 0 0 1 3.228-5.717z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M32.263 35.115c-.247.287-6.293 6.348-3.257 15.096q.522 1.51 1.21 3.398a.29.29 0 0 0 .549-.113l.482-4.69a8.13 8.13 0 0 1 3.228-5.717z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M32.263 35.115c-.247.287-6.293 6.348-3.257 15.096q.522 1.51 1.21 3.398a.29.29 0 0 0 .549-.113l.482-4.69a8.13 8.13 0 0 1 3.228-5.717z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCE7E0",
    d: "M47.603 35.115c.246.287 6.293 6.348 3.258 15.096q-.523 1.51-1.21 3.398a.291.291 0 0 1-.55-.113l-.482-4.69a8.37 8.37 0 0 0-3.233-5.829z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M47.603 35.115c.246.287 6.293 6.348 3.258 15.096q-.523 1.51-1.21 3.398a.291.291 0 0 1-.55-.113l-.482-4.69a8.37 8.37 0 0 0-3.233-5.829z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M47.603 35.115c.246.287 6.293 6.348 3.258 15.096q-.523 1.51-1.21 3.398a.291.291 0 0 1-.55-.113l-.482-4.69a8.37 8.37 0 0 0-3.233-5.829z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M47.603 35.115c.246.287 6.293 6.348 3.258 15.096q-.523 1.51-1.21 3.398a.291.291 0 0 1-.55-.113l-.482-4.69a8.37 8.37 0 0 0-3.233-5.829z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M47.603 35.115c.246.287 6.293 6.348 3.258 15.096q-.523 1.51-1.21 3.398a.291.291 0 0 1-.55-.113l-.482-4.69a8.37 8.37 0 0 0-3.233-5.829z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.271 1.515a22.79 22.79 0 0 0-8.82 19.556l2.808 21.81a.285.285 0 0 0 .29.223l6.451-.07 6.45-.068a.286.286 0 0 0 .284-.229l2.506-21.865A22.78 22.78 0 0 0 40.014 1.51a.62.62 0 0 0-.743.006"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M39.271 1.515a22.79 22.79 0 0 0-8.82 19.556l2.808 21.81a.285.285 0 0 0 .29.223l6.451-.07 6.45-.068a.286.286 0 0 0 .284-.229l2.506-21.865A22.78 22.78 0 0 0 40.014 1.51a.62.62 0 0 0-.743.006"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M39.271 1.515a22.79 22.79 0 0 0-8.82 19.556l2.808 21.81a.285.285 0 0 0 .29.223l6.451-.07 6.45-.068a.286.286 0 0 0 .284-.229l2.506-21.865A22.78 22.78 0 0 0 40.014 1.51a.62.62 0 0 0-.743.006"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M39.271 1.515a22.79 22.79 0 0 0-8.82 19.556l2.808 21.81a.285.285 0 0 0 .29.223l6.451-.07 6.45-.068a.286.286 0 0 0 .284-.229l2.506-21.865A22.78 22.78 0 0 0 40.014 1.51a.62.62 0 0 0-.743.006"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M39.271 1.515a22.79 22.79 0 0 0-8.82 19.556l2.808 21.81a.285.285 0 0 0 .29.223l6.451-.07 6.45-.068a.286.286 0 0 0 .284-.229l2.506-21.865A22.78 22.78 0 0 0 40.014 1.51a.62.62 0 0 0-.743.006"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCE7E0",
    d: "M39.545 53.405a1.6 1.6 0 0 1-.095-.396l-.194-1.314c-.475-3.217-.945-6.435-1.491-9.641-.246-1-.277-2.04-.09-3.053a2.43 2.43 0 0 1 2.123-1.923 2.435 2.435 0 0 1 2.155 1.911 7.4 7.4 0 0 1-.059 3.076c-.56 3.588-.957 7.2-1.439 10.8-.045.334-.295 1.277-.807.707a.6.6 0 0 1-.103-.167"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M39.545 53.405a1.6 1.6 0 0 1-.095-.396l-.194-1.314c-.475-3.217-.945-6.435-1.491-9.641-.246-1-.277-2.04-.09-3.053a2.43 2.43 0 0 1 2.123-1.923 2.435 2.435 0 0 1 2.155 1.911 7.4 7.4 0 0 1-.059 3.076c-.56 3.588-.957 7.2-1.439 10.8-.045.334-.295 1.277-.807.707a.6.6 0 0 1-.103-.167"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M39.545 53.405a1.6 1.6 0 0 1-.095-.396l-.194-1.314c-.475-3.217-.945-6.435-1.491-9.641-.246-1-.277-2.04-.09-3.053a2.43 2.43 0 0 1 2.123-1.923 2.435 2.435 0 0 1 2.155 1.911 7.4 7.4 0 0 1-.059 3.076c-.56 3.588-.957 7.2-1.439 10.8-.045.334-.295 1.277-.807.707a.6.6 0 0 1-.103-.167"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M39.545 53.405a1.6 1.6 0 0 1-.095-.396l-.194-1.314c-.475-3.217-.945-6.435-1.491-9.641-.246-1-.277-2.04-.09-3.053a2.43 2.43 0 0 1 2.123-1.923 2.435 2.435 0 0 1 2.155 1.911 7.4 7.4 0 0 1-.059 3.076c-.56 3.588-.957 7.2-1.439 10.8-.045.334-.295 1.277-.807.707a.6.6 0 0 1-.103-.167"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M39.545 53.405a1.6 1.6 0 0 1-.095-.396l-.194-1.314c-.475-3.217-.945-6.435-1.491-9.641-.246-1-.277-2.04-.09-3.053a2.43 2.43 0 0 1 2.123-1.923 2.435 2.435 0 0 1 2.155 1.911 7.4 7.4 0 0 1-.059 3.076c-.56 3.588-.957 7.2-1.439 10.8-.045.334-.295 1.277-.807.707a.6.6 0 0 1-.103-.167"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCE7E0",
    d: "M31.753 11.805a14.6 14.6 0 0 0 8.02 2.297c2.84-.029 5.61-.885 7.971-2.464a23.5 23.5 0 0 0-7.73-10.13.62.62 0 0 0-.743.008 23.53 23.53 0 0 0-7.518 10.289"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M31.753 11.805a14.6 14.6 0 0 0 8.02 2.297c2.84-.029 5.61-.885 7.971-2.464a23.5 23.5 0 0 0-7.73-10.13.62.62 0 0 0-.743.008 23.53 23.53 0 0 0-7.518 10.289"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M31.753 11.805a14.6 14.6 0 0 0 8.02 2.297c2.84-.029 5.61-.885 7.971-2.464a23.5 23.5 0 0 0-7.73-10.13.62.62 0 0 0-.743.008 23.53 23.53 0 0 0-7.518 10.289"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M31.753 11.805a14.6 14.6 0 0 0 8.02 2.297c2.84-.029 5.61-.885 7.971-2.464a23.5 23.5 0 0 0-7.73-10.13.62.62 0 0 0-.743.008 23.53 23.53 0 0 0-7.518 10.289"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M31.753 11.805a14.6 14.6 0 0 0 8.02 2.297c2.84-.029 5.61-.885 7.971-2.464a23.5 23.5 0 0 0-7.73-10.13.62.62 0 0 0-.743.008 23.53 23.53 0 0 0-7.518 10.289"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCE7E0",
    d: "M34.915 26.26a4.95 4.95 0 1 0 9.9 0 4.95 4.95 0 0 0-9.9 0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M34.915 26.26a4.95 4.95 0 1 0 9.9 0 4.95 4.95 0 0 0-9.9 0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M34.915 26.26a4.95 4.95 0 1 0 9.9 0 4.95 4.95 0 0 0-9.9 0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M34.915 26.26a4.95 4.95 0 1 0 9.9 0 4.95 4.95 0 0 0-9.9 0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M34.915 26.26a4.95 4.95 0 1 0 9.9 0 4.95 4.95 0 0 0-9.9 0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.932 26.26a2.933 2.933 0 1 0 5.866 0 2.933 2.933 0 0 0-5.866 0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M36.932 26.26a2.933 2.933 0 1 0 5.866 0 2.933 2.933 0 0 0-5.866 0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M36.932 26.26a2.933 2.933 0 1 0 5.866 0 2.933 2.933 0 0 0-5.866 0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M36.932 26.26a2.933 2.933 0 1 0 5.866 0 2.933 2.933 0 0 0-5.866 0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    d: "M36.932 26.26a2.933 2.933 0 1 0 5.866 0 2.933 2.933 0 0 0-5.866 0"
  })));
};
export default SvgRocketStartup;